module.exports = __webpack_public_path__ + "img/BCY.54845f47.svg";